// extracted by mini-css-extract-plugin
export default {"consents":"consents__FcoQ0"};